






import { Component, Mixins, Watch } from 'vue-property-decorator';
import { AuthInfo } from '@luxtag/papybase';
import { MUTATE_AUTH } from '../../../store/modules/auth';
import ProductIntegrationMixin from '@/mixins/vue/ProductIntegrationMixin';
import { auth } from '@/plugins/papybase/papybaseInit';

@Component
export default class GoogleCallback extends Mixins(ProductIntegrationMixin) {
    public async googleSignIn(accessToken: string) {
        const that = this;
        try {
            // await auth.signInWithGoogle(accessToken);
            const authInfo = await auth.signInWithGoogle(accessToken);
            that.loginSuccess(authInfo);
        } catch (error) {
            console.error(error);
            // this.messageHeader = 'Login failed';
            // this.messageContent = 'Your account is not found';
            // this.showSimpleDialog = true;
        }
    }

    public async loginSuccess(user: AuthInfo) {
        // get template
        await this.integrateProductListFromBackEndToLocalStorage(user.jwt);
        const theUser: any = user;
        theUser.login = true;
        this.$store.commit(MUTATE_AUTH, theUser);
        this.$router.replace('/');
    }

    get route(): any {
        return this.$route;
    }

    @Watch('route', { immediate: true })
    private onRouteChange(val: any) {
        this.modifyPath(val);
    }

    private modifyPath(route: any) {
        const path = route.fullPath;
        if (path.search('#') !== -1) {
            // replace # into ?
            // console.log('path');
            this.$router.replace(path.replace('#', '?'));
        } else {
            // console.log('query', route.query);
            // this.googleSignIn(route.query);
        }
    }

    private executeQuery(query: any) {

    }
}
